/* global angular */
( function () {
	'use strict';

	function reportComponentPage ( reportService, location, logger ) {
		var self = this;

		function goToList ( ) {
			location.path( '/report' );
			logger.notifyError( 'Sorry, the page you requested is not available or does not exist.' );
		}

		function activate () {
			self.report = location.search().report;
		}

		activate();
		self.hasPdfMake = reportService.hasPdfMake;
		self.goToList   = goToList;
	}

	angular
		.module( 'app.report' )
		.controller( 'reportComponentPage', reportComponentPage );

	reportComponentPage.$inject = [ 'reportService', '$location', 'logger' ];
} )( );
